import "./FsdCustomerDatePicker.scss";

import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Radio } from "react-bootstrap";
import { getDay } from "date-fns";
import { formatTimeSlots } from "../common/DeliveryTimeSlots";
import { formatLocalDate, parseDate } from "../../utils/DateUtil";
import type { IntlShape } from "react-intl";

type FsdCustomerDatePickerProps = {
	intl: IntlShape;
	dates: Map<string, any>;
	validDates: string[];
	selectedDate?: Date | null;
	onSelect: (date: Date) => void;
	dateFormat: string;
	onClose: () => void;
};

export const DisconnectedFsdCustomerDatePicker = ({
	intl,
	dates,
	validDates,
	selectedDate,
	onSelect,
	dateFormat,
	onClose,
}: FsdCustomerDatePickerProps) => {
	const renderDates = renderFsdDates(validDates, dates, selectedDate, dateFormat, onSelect, intl);
	return (
		<div className="mfcss_fsd_datepicker_container">
			<div className={"mfcss_datepicker_fsd_header"}>
				<FormattedMessage id={"ORC_CONFIRMATION_PAGE_DELIVERY_DATE_TITLE"} />
			</div>
			<div className="mfcss_fsd_date_picker">{renderDates}</div>
			<div className="mfcss_datepicker_fsd_footer">
				<a onClick={onClose}>
					{intl.formatMessage({
						id: "ORC_SHOPPINGCARTPAGE_UPLOAD_MODAL_BUTTON_CLOSE",
					})}
				</a>
			</div>
		</div>
	);
};

const renderFsdDates = (
	validDates: string[],
	dates,
	selectedDate: Date | null | undefined,
	dateFormat: string,
	onSelect,
	intl: IntlShape,
): React.ReactNode => {
	const DAY_I18N_KEYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
	return validDates.map((validDate) => {
		const parsedValidDate = parseDate(validDate);
		const isSelected = selectedDate?.getTime() === parsedValidDate.getTime();
		const labelCssClass = isSelected
			? "mfcss_datepicker_fsd_slot_label selected"
			: "mfcss_datepicker_fsd_slot_label unselected";
		const dateText =
			intl
				.formatMessage({
					id: DAY_I18N_KEYS[getDay(parsedValidDate)],
				})
				.substring(0, 2) +
			",\xa0" +
			formatLocalDate(parsedValidDate, dateFormat);
		const deliveryTimes = dates.get(validDate).deliveryTimes.slice(0, 1);
		const slotText = formatTimeSlots(parsedValidDate, deliveryTimes);
		return (
			<Radio
				key={validDate}
				checked={isSelected}
				name="fsd-delivery-date-radio"
				onChange={() => onSelect(parsedValidDate)}
			>
				<span className={labelCssClass}>
					<span className={"mfcss_datepicker_fsd_delivery_date"}>{dateText}</span>
					<span className={"mfcss_datepicker_fsd_delivery_slot"}>{slotText}</span>
				</span>
			</Radio>
		);
	});
};

export const FsdCustomerDatePicker = injectIntl(DisconnectedFsdCustomerDatePicker);
